<template>
    <v-select
        :items="statuses"
        item-value="id"
        item-text="name"
        :value="value"
        :label="label || $t('attributes.state')"
        @input="$emit('input', $event)"
        clearable
        :outlined="outlined"
        :error-messages="errorMessages"
    />
</template>

<script>
export default {
    name: "SellOffersStatusesField",

    props: {
        value: [String, Number, Boolean],
        label: { type: String },
        outlined: {
            type: Boolean,
            default: false
        },
        errorMessages: [String, Array]
    },

    data() {
        return {
            statuses: [
                { id: "1", name: "فعال" },
                { id: "2", name: "مباع" },
                { id: "3", name: "ملغي" }
            ]
        };
    }
};
</script>
